"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderBookV2WebSocket = void 0;
const rxjs_1 = require("rxjs");
const SubsPairMgr_1 = require("./base/SubsPairMgr");
const BaseWebSocket_1 = require("./BaseWebSocket");
const QuotationSocketMgr_1 = require("./QuotationSocketMgr");
const obItemMemory = [];
function processOrderBookItemsAndMaxQuantity(wsItems) {
    if (!wsItems) {
        return { items: [], maxQuantity: 0 };
    }
    let accQuantity = 0;
    let accVolume = 0;
    let maxQuantity = 0;
    wsItems.forEach((item, index) => {
        const price = parseFloat(item[0]);
        const quantity = parseFloat(item[1]);
        const volume = price * quantity;
        accQuantity += quantity;
        accVolume += volume;
        if (quantity > maxQuantity) {
            maxQuantity = quantity;
        }
        obItemMemory[index] = {
            index,
            price,
            quantity,
            volume,
            accQuantity,
            accVolume,
        };
    });
    return { items: obItemMemory.slice(0, wsItems.length), maxQuantity };
}
class OrderBookV2WebSocket extends BaseWebSocket_1.BaseWebSocket {
    constructor() {
        super(...arguments);
        this.dataCache = new Map();
        this.orderBookPairPoolMgr = new SubsPairMgr_1.SubsPairMgr(QuotationSocketMgr_1.SubscribeEventType.odbGroup, (type, params, registerMap) => {
            const paramsMap = new Map();
            params.forEach((item) => {
                const { precision, limit } = item, origin = __rest(item, ["precision", "limit"]);
                const symbolKey = this.getSymbolKey(item);
                const paramItem = paramsMap.get(symbolKey) || Object.assign(Object.assign({}, origin), { precisions: [] });
                const precisionData = { limit };
                if (precision) {
                    precisionData.precision = precision;
                }
                if (!paramItem.precisions.some((item) => item.precision === precisionData.precision && item.limit === precisionData.limit)) {
                    paramItem.precisions.push(precisionData);
                }
                paramsMap.set(symbolKey, paramItem);
            });
            return this.send(type, Array.from(paramsMap.values()).sort());
        });
    }
    getSymbolKey(data) {
        return `${data.market}/${data.base}/${data.quote}`;
    }
    getPrecisionKey(data) {
        return `${data.precision || "default"}/${data.limit}`;
    }
    getCacheDataKey(data) {
        return `${this.getSymbolKey(data)}_${this.getPrecisionKey(data)}`;
    }
    getCacheSubject(data) {
        const key = this.getCacheDataKey(data);
        const cache = this.dataCache.get(key);
        if (cache) {
            return cache;
        }
        const sub = new rxjs_1.Subject();
        this.dataCache.set(key, sub);
        return sub;
    }
    handleOrderBookData(pushData) {
        var _a;
        if (!pushData || pushData.length === 0) {
            return;
        }
        for (let wsData of pushData) {
            const { items: bids, maxQuantity: bidsMaxQuantity } = processOrderBookItemsAndMaxQuantity(wsData.d);
            const { items: asks, maxQuantity: asksMaxQuantity } = processOrderBookItemsAndMaxQuantity(wsData.a);
            const maxQuantity = Math.max(bidsMaxQuantity, asksMaxQuantity);
            const maxAccQuantity = Math.max(bids.length >= 0 ? bids[bids.length - 1].accQuantity : 0, asks.length >= 0 ? asks[asks.length - 1].accQuantity : 0);
            const data = {
                exchange: wsData.e,
                base: wsData.b,
                quote: wsData.q,
                precision: wsData.p,
                limit: wsData.l,
                maxQuantity,
                maxAccQuantity,
                bids,
                asks,
            };
            (_a = this.getCacheSubject({
                market: data.exchange,
                base: data.base,
                quote: data.quote,
                limit: data.limit,
                precision: data.precision,
            })) === null || _a === void 0 ? void 0 : _a.next(data);
        }
    }
    /**
     * 订阅OrderBook推送
     * exchange default is pionex.v2
     */
    getOrderBookObservable(params) {
        this.orderBookPairPoolMgr.addSubscribePair([params]);
        return new rxjs_1.Observable((observer) => {
            const subscription = this.getCacheSubject(params).subscribe({
                next: (result) => {
                    if (result) {
                        observer.next(result);
                    }
                },
                error: (err) => {
                    console.log(err);
                }
            });
            observer.add(() => {
                subscription.unsubscribe();
                this.orderBookPairPoolMgr.removeSubscribePair([params]);
            });
        });
    }
}
exports.OrderBookV2WebSocket = OrderBookV2WebSocket;
